<template>
    <div>
        <div class="header">助学金申请</div>
        <div class="box">
            <inner-table id="innerGrant" ref="grantList" :listviewurl="'studentGrantApplication.listAllFile'" :can-edit="0" :can-delete="0" :link-prop-name="'studentId'" />
        </div>
        <div class="header" style="margin-top: 2px;">免学费申请</div>
        <div class="box">
            <inner-table id="innerTuition" ref="tuitionList" :listviewurl="'studentTuitionWaiverApplication.listAllFile'" :can-edit="0" :can-delete="0" :link-prop-name="'studentId'" />
        </div>
  </div>
</template>

<script>
export default {
    props: {
        vo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 0 }
    },
    data() {
        return {
        }
    },
    computed: {},
    watch: {},
    created: function() {
    },
    mounted: function() {
    },
    methods: {
        onInnerCellClick(){

        },
        onInnerTableListDataBeforeLoad($scope, qparams) {
            qparams.urlsearch = `studentId:${this.vo?.studentId}`
        }
    }
}
</script>

<style scoped>
.header {
    padding:10px 5px;
    background-color: #f2f5fb;
    border-top: 1px solid #999;
    border-left: 1px solid #999;
    border-right: 1px solid #999;
    font-size: 14px;
    font-weight: 500;
}
.box {
   border:1px solid #999;
}
</style>

